import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { RelatedSearchLinks } from './RelatedSearchLinks';
import { getKeywordsFromLocalStorage, getKeywordsFromCookie } from '../../helpers/recent-searches';

export const RecentSearch = () => {
  const title = 'Recent Searches';
  const { channel } = useContext(ExperienceContext);

  const relatedKeywords = channel === 'mobile' ? getKeywordsFromCookie() : getKeywordsFromLocalStorage();

  return (
    <div className="related-search">
      {
        !!relatedKeywords?.length
        && <RelatedSearchLinks relatedLinks={relatedKeywords} title={title} />
      }
    </div>
  );
};
